import { createRouter, createWebHashHistory } from "vue-router";

export default async ({ store }) => {
  let routes = [
    //applicants routes
    {
      path: "/applicants/view",
      name: "applicantsview",
      component: () => import("./pages/applicants/view.vue"),
      props: true,
    },

    {
      path: "/applicants/edit",
      name: "applicantsedit",
      component: () => import("./pages/applicants/edit.vue"),
      props: true,
    },

    {
      path: "/applicants/biodata",
      name: "applicantsbiodata",
      component: () => import("./pages/applicants/biodata.vue"),
      props: true,
    },

    {
      path: "/applicants/familydata",
      name: "applicantsfamilydata",
      component: () => import("./pages/applicants/familydata.vue"),
      props: true,
    },

    {
      path: "/applicants/academicsdata",
      name: "applicantsacademicsdata",
      component: () => import("./pages/applicants/academicsdata.vue"),
      props: true,
    },

    {
      path: "/applicants/programmesdata",
      name: "applicantsprogrammesdata",
      component: () => import("./pages/applicants/programmesdata.vue"),
      props: true,
    },

    {
      path: "/applicants/fundingdata",
      name: "applicantsfundingdata",
      component: () => import("./pages/applicants/fundingdata.vue"),
      props: true,
    },

    {
      path: "/applicants/payment",
      name: "applicantspayment",
      component: () => import("./pages/applicants/payment.vue"),
      props: true,
    },
    {
      path: "/applicants/summarydata",
      name: "applicantssummarydata",
      component: () => import("./pages/applicants/summarydata.vue"),
      props: true,
    },

    {
      path: "/applicants/results",
      name: "applicantsresults",
      component: () => import("./pages/applicants/results.vue"),
      props: true,
    },

    {
      path: "/index/register",
      name: "applicantsuserregister",
      component: () => import("./pages/index/userregister.vue"),
      props: true,
    },

    {
      path: "/account/edit",
      name: "applicantsaccountedit",
      component: () => import("./pages/account/accountedit.vue"),
      props: true,
    },

    {
      path: "/account",
      name: "applicantsaccountview",
      component: () => import("./pages/account/accountview.vue"),
      props: true,
    },

    //caps_programmes_list routes
    {
      path: "/custom/programmes_record_view/:id",
      name: "programmesrecordview",
      component: () => import("./pages/custom/programmes_record_view.vue"),
      props: true,
    },

    //caps_institutions_list routes
    {
      path: "/custom/institutions_record_view/:id",
      name: "institutionsrecordview",
      component: () => import("./pages/custom/institutions_record_view.vue"),
      props: true,
    },

    //minimum_entry_requirements routes
    {
      path: '/minimum_entry_requirements',
      alias: '/minimum_entry_requirements/:fieldName/:fieldValue',
      name: 'minimum_entry_requirementslist',
      component: () => import('./pages/minimum_entry_requirements/list.vue'),
      props: true
    },

    // Info Pages
    {
      path: "/info/help",
      name: "helppage",
      component: () => import("./pages/info/help.vue"),
      props: true,
    },

    // CAPS Mall
    {
      path: "/capsmall/programmes",
      name: "capsmallprogrammes",
      component: () => import("./pages/capsmall/programmes.vue"),
      props: true,
    },

    {
      path: "/capsmall/programmeapply",
      name: "capsmallprogrammeapply",
      component: () => import("./pages/capsmall/programmeapply.vue"),
      props: true,
    },

    {
      path: "/capsmall/programmeselections",
      name: "capsmallprogrammeselections",
      component: () => import("./pages/capsmall/programmeselections.vue"),
      props: true,
    },

    {
      path: "/applicant_selected_grants/edit/:id",
      name: "applicant_selected_grantsedit",
      component: () => import("./pages/applicant_selected_grants/edit.vue"),
      props: true,
    },

    //Otp verify code routes
    {
      path: "/index/verifyotp",
      name: "verifyotp",
      component: () => import("./pages/index/verifyotp.vue"),
      props: true,
    },

    //Password reset routes
    {
      path: "/index/forgotpassword",
      name: "forgotpassword",
      component: () => import("./pages/index/forgotpassword.vue"),
      props: true,
    },
    {
      path: "/index/resetpassword",
      name: "resetpassword",
      component: () => import("./pages/index/resetpassword.vue"),
      props: true,
    },
    {
      path: "/index/resetpassword_completed",
      name: "resetpassword_completed",
      component: () => import("./pages/index/resetpassword_completed.vue"),
      props: true,
    },

    //Email verify routes
    {
      path: "/index/verifyemail",
      name: "verifyemail",
      component: () => import("./pages/index/verifyemail.vue"),
      props: true,
    },
    {
      path: "/index/emailverified",
      name: "emailverified",
      component: () => import("./pages/index/emailverified.vue"),
      props: true,
    },

    {
      path: "/error/forbidden",
      name: "forbidden",
      component: () => import("./pages/errors/forbidden.vue"),
      props: true,
    },
    {
      path: "/error/notfound",
      name: "notfound",
      component: () => import("./pages/errors/pagenotfound.vue"),
      props: true,
    },
    {
      path: "/:catchAll(.*)",
      component: () => import("./pages/errors/pagenotfound.vue"),
    },
  ];

  let loginToken = store.getters["auth/getLoginToken"];
  if (loginToken) {
    //Token is available, user might still be logged in
    try {
      //fetch user data for the first time and saves in the vuex store
      await store.dispatch("auth/getUserData");
    } catch (e) {
      store.dispatch("auth/logout"); //token must have expired
    }
  }

  let user = store.state.auth.user;
  if (user) {
    routes.push({
      path: "/",
      alias: "/home",
      name: "home",
      component: () => import(`./pages/home/home.vue`),
      props: true,
    });
  } else {
    routes.push({
      path: "/",
      alias: "/index",
      name: "index",
      component: () => import("./pages/index/index.vue"),
      props: true,
    });
  }

  const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) return savedPosition;
      return { x: 0, y: 0 };
    },
  });
  return router;
};
